import { Box, Dialog } from "@mui/material";
import React from "react";
import TabPanel from "../../../UtilitiesComponent/TabPanel";

const UpdateSuccessfullModal = ({ succesUpdate, onClose }) => {
  let statuses = [1, 2, 5];

  return (
    <Dialog
      onClose={onClose}
      open={statuses.includes(succesUpdate) ? true : false}
      className="successfullDialog"
    >
      {/* <Box className="successfullModal">
        <p>Message Sent Successfully</p>
      </Box> */}
      <TabPanel value={succesUpdate} index={1}>
        <Box className="successfullModalApproved">
          <p>
            Video <span>Approved</span> Successfully
          </p>
        </Box>
      </TabPanel>
      <TabPanel value={succesUpdate} index={2}>
        <Box className="successfullModalReject">
          <p>
            Video <span>Rejected</span> Successfully
          </p>
        </Box>
      </TabPanel>
      <TabPanel value={succesUpdate} index={5}>
        <Box className="successfullModalWebsite">
          <p>
            Video Approved for <span>Website Only</span> Posting
          </p>
        </Box>
      </TabPanel>
    </Dialog>
  );
};

export default UpdateSuccessfullModal;
